<template>
  <div>
    <b-overlay
      id="overlay-background"
      :show="loader === true"
      variant="dark"
      opacity="0.85"
      blur="2px"
      rounded="sm"
      spinner-variant="primary"
      spinner-medium
    >
      <debtor-form
        :clients="clientsObj"
      />
    </b-overlay>
  </div>
</template>

<script>
import {
  BFormInvalidFeedback, BOverlay,
} from 'bootstrap-vue'
import { avatarText } from '@core/utils/filter'
import { ref, reactive } from '@vue/composition-api'
import axios from '@axios'
import DebtorForm from './DebtorForm.vue'

export default {
  components: {
    BOverlay,
    DebtorForm,
  },
  setup() {
    const loader = ref(false)
    const clientsObj = reactive([])
    const clients = async () => {
      loader.value = true
      await axios.get('clients/dropdown')
        .then(response => {
          loader.value = false
          clientsObj.push(...response.data.data)
        }).catch(error => {
          console.log(error)
        })
    }
    clients()
    return {
      avatarText,
      loader,
      BFormInvalidFeedback,
      clients,
      clientsObj,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.spinner-border{
  width: 6rem;
  height: 6rem;
}
</style>
